import apiPaths from '../api-paths.js';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.STAFF }/declarations${ query }`);
  },
  generate({ employee, type, year }) {
    return axios.post(`${ apiPaths.STAFF }/declarations/generate`, { employee, type, year });
  },
  refreshStatus(id) {
    return axios.get(`${ apiPaths.STAFF }/declarations/refresh-status/${ id }`);
  },
  prepareXml({ xml }) {
    return axios.post(`${ apiPaths.STAFF }/declarations/prepare-xml`, { xml });
  },
};
